import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../../model/rodeo';
import { PayoutSource } from '../../../../../model/payout-source';

@Component({
    selector: 'payout-source',
    templateUrl: 'payout-source.html'
})
export class PayoutSourceModal {
    rodeo: Rodeo;
    payoutSource: PayoutSource;
    editing: boolean;

    rounds: number[];

    showAdvanced: boolean;

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeo = navParams.get('rodeo');
        this.payoutSource = navParams.get('payoutSource');

        if (!this.payoutSource) {
            this.payoutSource = new PayoutSource();
        } else {
            this.editing = true;
        }

        this.updateRounds();
    }

    getMaxMoney() {
        let maxMoney = 0;
        let rodeoEvent = null;
        
        if (this.payoutSource.rodeoEventId)
            rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == this.payoutSource.rodeoEventId)[0];
        
        if (rodeoEvent)
            maxMoney = Math.max(maxMoney, this.rodeo.rodeoEvents.filter(x => x.id == this.payoutSource.rodeoEventId)[0].entryCost);

        if (this.payoutSource.sidepotId && rodeoEvent.sidepots.some(x => x.id == this.payoutSource.sidepotId)) 
            maxMoney = Math.max(maxMoney, rodeoEvent.sidepots.filter(x => x.id == this.payoutSource.sidepotId)[0].cost);

        return maxMoney;
    }

    updateRounds() {
        if (this.payoutSource.rodeoEventId) {
            let rodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id == this.payoutSource.rodeoEventId)[0];

            if (rodeoEvent) {
                this.rounds = [];

                this.rounds.push(0);

                for (let i = 0; i < rodeoEvent.rounds + (rodeoEvent.shortGo ? 1 : 0); i++) {
                    this.rounds.push(i + 1);
                }

                if (!this.payoutSource.round || !this.rounds.some(x => x == this.payoutSource.round)) {
                    this.payoutSource.round = this.rounds[0];
                }

                if (!this.editing)
                    this.payoutSource.amountToPot = +(rodeoEvent.priceTiers[0].unitPrice * .8).toFixed(0);
            }
        }
    }
    
    create() {
        this.viewController.dismiss(this.payoutSource);
    }

    remove() {
        this.viewController.dismiss(0);
    }

    cancel() {
        this.viewController.dismiss(null);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/payouts/payout-source.ts